import { render, staticRenderFns } from "./VatNumberBlock.vue?vue&type=template&id=e2ceaa00&scoped=true"
import script from "./VatNumberBlock.vue?vue&type=script&lang=js"
export * from "./VatNumberBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2ceaa00",
  null
  
)

export default component.exports